var _style, _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExpensifyLogoNew = function SvgExpensifyLogoNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "expensify-logo-new_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 81 81",
    style: {
      enableBackground: "new 0 0 81 81"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".expensify-logo-new_svg__st0{fill-rule:evenodd;clip-rule:evenodd}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "expensify-logo-new_svg__SVGID_1_",
    d: "M.8 0h80v80H.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "expensify-logo-new_svg__SVGID_00000144338341264450383030000002729908262559559608_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#expensify-logo-new_svg__SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#expensify-logo-new_svg__SVGID_00000144338341264450383030000002729908262559559608_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.9 28.2v-8.3H26.6v40.3h28.2v-8.3H37v-7.7h14.4v-8.5H37v-7.3h17.9z",
    className: "expensify-logo-new_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8 6.5c7.1 0 13.7 2.2 19.2 6 1.4 1 3.3.9 4.5-.3 1.3-1.3 1.3-3.5-.3-4.7C57.5 2.8 49.5 0 40.8 0 18.7 0 .8 17.9.8 40c0 8.7 2.8 16.8 7.5 23.3 1.1 1.5 3.3 1.6 4.7.3 1.2-1.2 1.3-3.1.3-4.5-3.8-5.4-6-12-6-19.2 0-18.4 14.9-33.4 33.5-33.4-.1 0 0 0 0 0zM73.7 17.4c-1.1-1.6-3.4-1.7-4.7-.3-1.2 1.2-1.3 3-.4 4.4 3.5 5.3 5.6 11.7 5.6 18.5 0 6.8-2.1 13.4-5.8 18.8-.9 1.4-.9 3.3.3 4.5 1.4 1.4 3.6 1.3 4.7-.3 4.6-6.5 7.3-14.4 7.3-23 .1-8.5-2.5-16.2-7-22.6zM40.8 73.5c-6.8 0-13.2-2.1-18.5-5.6-1.4-.9-3.3-.8-4.4.4-1.4 1.4-1.3 3.6.3 4.7 6.4 4.4 14.2 7 22.6 7 8.4 0 16.4-2.7 23-7.3 1.6-1.1 1.7-3.3.3-4.7-1.2-1.2-3.1-1.3-4.5-.3-5.4 3.6-11.9 5.8-18.8 5.8z",
    className: "expensify-logo-new_svg__st0"
  }))));
};
export default SvgExpensifyLogoNew;